// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Draggable_Draggable__hL5Hi {
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	transition: transform 250ms ease;

	> button {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 54px;
		flex-shrink: 1;
		appearance: none;
		outline: none;
		border: 0;
		padding: 8px 18px;
		background-color: #181a22;
		border-radius: 5px;
		box-shadow: var(--box-shadow);
		transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)
			scale(var(--scale, 1));
		transition: box-shadow 300ms ease;
	}

	&:not(.Draggable_handle__RFfKU) {
		> button {
			touch-action: none;
			cursor: grab;

			&:focus-visible:not(.Draggable_active__gt-Le &) {
				box-shadow: 0 0 0 3px #4c9ffe;
			}
		}
	}

	&.Draggable_handle__RFfKU {
		> button {
			--action-background: rgba(255, 255, 255, 0.1);

			> svg {
				margin-right: 5px;
			}

			> button {
				margin-right: -10px;
			}
		}
	}

	img {
		width: 140px;
		-webkit-user-select: none;
		        user-select: none;
		pointer-events: none;
	}

	label {
		display: block;
		flex-shrink: 1;
		padding: 10px;
		transition: opacity 250ms ease;

		text-align: center;
		font-size: 1rem;
		font-weight: 300;
		color: #8d8d8d;
		-webkit-user-select: none;
		        user-select: none;
		cursor: auto;

		animation-name: Draggable_pulse__R2iD\\+;
		animation-duration: 1.5s;
		animation-delay: 2s;
		animation-iteration-count: infinite;
		animation-timing-function: ease;
		animation-direction: alternate;
	}

	&.Draggable_dragging__ArPnp {
		z-index: 1;
		transition: none;

		* {
			cursor: grabbing;
		}

		> button {
			--scale: 1.06;
			--box-shadow: -1px 0 15px 0 rgba(34, 33, 81, 0.01),
				0px 15px 15px 0 rgba(34, 33, 81, 0.25);

			&:focus-visible {
				--box-shadow: 0 0px 10px 2px #4c9ffe;
			}
		}

		label {
			animation: none;
			opacity: 0;
		}
	}

	&.Draggable_dragOverlay__hCDva,
	&.Draggable_dragging__ArPnp {
		> button {
			animation: Draggable_pop__rKai3 250ms cubic-bezier(0.18, 0.67, 0.6, 1.22);
		}
	}
}

@keyframes Draggable_pulse__R2iD\\+ {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes Draggable_pop__rKai3 {
	0% {
		transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)
			scale(1);
	}
	100% {
		transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)
			scale(var(--scale));
		box-shadow: var(--box-shadow);
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/Draggable/Draggable.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CACvB,gCAAgC;;CAEhC;EACC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B;yBACuB;EACvB,iCAAiC;CAClC;;CAEA;EACC;GACC,kBAAkB;GAClB,YAAY;;GAEZ;IACC,6BAA6B;GAC9B;EACD;CACD;;CAEA;EACC;GACC,6CAA6C;;GAE7C;IACC,iBAAiB;GAClB;;GAEA;IACC,mBAAmB;GACpB;EACD;CACD;;CAEA;EACC,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;CACrB;;CAEA;EACC,cAAc;EACd,cAAc;EACd,aAAa;EACb,8BAA8B;;EAE9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;;EAEZ,uCAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;CAC/B;;CAEA;EACC,UAAU;EACV,gBAAgB;;EAEhB;GACC,gBAAgB;EACjB;;EAEA;GACC,aAAa;GACb;0CACuC;;GAEvC;IACC,oCAAoC;GACrC;EACD;;EAEA;GACC,eAAe;GACf,UAAU;EACX;CACD;;CAEA;;EAEC;GACC,yEAAwD;EACzD;CACD;AACD;;AAEA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC;WACS;CACV;CACA;EACC;sBACoB;EACpB,6BAA6B;CAC9B;AACD","sourcesContent":[".Draggable {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n\tjustify-content: center;\n\ttransition: transform 250ms ease;\n\n\t> button {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmin-height: 54px;\n\t\tflex-shrink: 1;\n\t\tappearance: none;\n\t\toutline: none;\n\t\tborder: 0;\n\t\tpadding: 8px 18px;\n\t\tbackground-color: #181a22;\n\t\tborder-radius: 5px;\n\t\tbox-shadow: var(--box-shadow);\n\t\ttransform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)\n\t\t\tscale(var(--scale, 1));\n\t\ttransition: box-shadow 300ms ease;\n\t}\n\n\t&:not(.handle) {\n\t\t> button {\n\t\t\ttouch-action: none;\n\t\t\tcursor: grab;\n\n\t\t\t&:focus-visible:not(.active &) {\n\t\t\t\tbox-shadow: 0 0 0 3px #4c9ffe;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.handle {\n\t\t> button {\n\t\t\t--action-background: rgba(255, 255, 255, 0.1);\n\n\t\t\t> svg {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\n\t\t\t> button {\n\t\t\t\tmargin-right: -10px;\n\t\t\t}\n\t\t}\n\t}\n\n\timg {\n\t\twidth: 140px;\n\t\tuser-select: none;\n\t\tpointer-events: none;\n\t}\n\n\tlabel {\n\t\tdisplay: block;\n\t\tflex-shrink: 1;\n\t\tpadding: 10px;\n\t\ttransition: opacity 250ms ease;\n\n\t\ttext-align: center;\n\t\tfont-size: 1rem;\n\t\tfont-weight: 300;\n\t\tcolor: #8d8d8d;\n\t\tuser-select: none;\n\t\tcursor: auto;\n\n\t\tanimation-name: pulse;\n\t\tanimation-duration: 1.5s;\n\t\tanimation-delay: 2s;\n\t\tanimation-iteration-count: infinite;\n\t\tanimation-timing-function: ease;\n\t\tanimation-direction: alternate;\n\t}\n\n\t&.dragging {\n\t\tz-index: 1;\n\t\ttransition: none;\n\n\t\t* {\n\t\t\tcursor: grabbing;\n\t\t}\n\n\t\t> button {\n\t\t\t--scale: 1.06;\n\t\t\t--box-shadow: -1px 0 15px 0 rgba(34, 33, 81, 0.01),\n\t\t\t\t0px 15px 15px 0 rgba(34, 33, 81, 0.25);\n\n\t\t\t&:focus-visible {\n\t\t\t\t--box-shadow: 0 0px 10px 2px #4c9ffe;\n\t\t\t}\n\t\t}\n\n\t\tlabel {\n\t\t\tanimation: none;\n\t\t\topacity: 0;\n\t\t}\n\t}\n\n\t&.dragOverlay,\n\t&.dragging {\n\t\t> button {\n\t\t\tanimation: pop 250ms cubic-bezier(0.18, 0.67, 0.6, 1.22);\n\t\t}\n\t}\n}\n\n@keyframes pulse {\n\tfrom {\n\t\topacity: 0;\n\t}\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes pop {\n\t0% {\n\t\ttransform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)\n\t\t\tscale(1);\n\t}\n\t100% {\n\t\ttransform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)\n\t\t\tscale(var(--scale));\n\t\tbox-shadow: var(--box-shadow);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Draggable": `Draggable_Draggable__hL5Hi`,
	"pulse": `Draggable_pulse__R2iD+`,
	"pop": `Draggable_pop__rKai3`,
	"handle": `Draggable_handle__RFfKU`,
	"active": `Draggable_active__gt-Le`,
	"dragging": `Draggable_dragging__ArPnp`,
	"dragOverlay": `Draggable_dragOverlay__hCDva`
};
export default ___CSS_LOADER_EXPORT___;
